import apiSlice from './ApiSlice';

export const recordingRequestApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllRecordingRequest: builder.query({ 
      providesTags:['recording-request'],
        query: (body) => {
          return {
            url: "/recording-request",
            method: "POST",
            body,
          };
        },
      }),
      updateRequestStatus: builder.mutation({
        invalidatesTags:['recording-request'],
        query: ({body , id}) => {
          return {
            url: `/recording-request/${id}/approval`,
            method: "PUT",
            body,
          };
        },
      }),
      
  }),
});

export const {useGetAllRecordingRequestQuery , useUpdateRequestStatusMutation } = recordingRequestApi;